import type { ReactNode, DetailedHTMLProps, HTMLAttributes } from 'react'

import cn from 'classnames'

import styles from './app-text.module.css'

type TH4Props = DetailedHTMLProps<
  HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>

type TTitleProps = {
  children: ReactNode
} & TH4Props
type TParagraphHtmlProps = DetailedHTMLProps<
  HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>

type TParagraphProps = TParagraphHtmlProps & {
  children: ReactNode
}

export const Title = ({ children, ...props }: TTitleProps) => (
  <h4 className={cn(styles['title'])} {...props}>
    {children}
  </h4>
)

export const Paragraph = (props: TParagraphProps) => (
  <p className={styles.paragraph} {...props}>
    {props.children}
  </p>
)

export const AppText = () => null

AppText.Title = Title
AppText.Paragraph = Paragraph
